import { Navigate, useParams } from "react-router-dom";

/**
 * Historical consultation edit is not a safe POST. Redirect to read-only view
 * until a dedicated PUT editor is implemented.
 */
export default function ConsultationEditRedirect() {
  const { id } = useParams();
  if (!id) return <Navigate to="/dashboard" replace />;
  return <Navigate to={`/consulta/${id}`} replace />;
}
